import { render, staticRenderFns } from "./ObjectsTabs.vue?vue&type=template&id=cac38038&scoped=true"
import script from "./ObjectsTabs.vue?vue&type=script&lang=js"
export * from "./ObjectsTabs.vue?vue&type=script&lang=js"
import style0 from "./ObjectsTabs.vue?vue&type=style&index=0&id=cac38038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac38038",
  null
  
)

export default component.exports